// This component is deprecated - topbar title now comes from navigation config
// Keeping for backwards compatibility but it does nothing
// The page title "Predictions" will be shown automatically from the navigation config
export function PredictionsTopbar(): null {
  return null;
}
